import { useStore } from '@/store';

import { useAxios } from '@/vue3/hooks/axiosHook';
export const useAppPushNotificationService = () => {
    const store = useStore();
    const axios = useAxios();
    const url = store.state.apiUrl;
    const sendPlayerAppNotification = async (credentials) => {
        const res = await axios.post(
            `${url}/playerAppNotification`,
            credentials,
        );
        return res;
    };
    return {
        sendPlayerAppNotification,
    };
};
